// Allow overriding the base URL at runtime
let baseUrl = process.env.REACT_APP_API_URL || "http://localhost:3000";
export function setApiBaseUrl(url) {
    baseUrl = url;
}
export function getApiBaseUrl() {
    return baseUrl;
}
export async function fetchJSON(path, options) {
    const response = await fetch(`${baseUrl}${path}`, {
        method: options?.method || 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
        body: options?.body,
    });
    if (!response.ok)
        throw new Error(`API error: ${response.status}`);
    return response.json();
}
